import { render, staticRenderFns } from "./point-edit.vue?vue&type=template&id=c5625b70&scoped=true&"
import script from "./point-edit.vue?vue&type=script&lang=js&"
export * from "./point-edit.vue?vue&type=script&lang=js&"
import style0 from "./point-edit.vue?vue&type=style&index=0&id=c5625b70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5625b70",
  null
  
)

export default component.exports